import { render, staticRenderFns } from "./ReminderForm.vue?vue&type=template&id=028ed842&"
import script from "./ReminderForm.vue?vue&type=script&lang=js&"
export * from "./ReminderForm.vue?vue&type=script&lang=js&"
import style0 from "./ReminderForm.vue?vue&type=style&index=0&id=028ed842&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports